<template>
  <div class="chart13">
    <div id="Chart13" style="width: 500px; height: 260px"></div>
    <div class="chart13_table">
      <div class="chart13_table_box">
        <div class="chart13_table_box_option1">
          <div class="chart13_table_box_option1_left">
            <div class="chart13_table_box_option1_left_top">
              中金公司 <i class="i2">王文丹</i> 张向伟 江澜
            </div>
            <div class="chart13_table_box_option1_left_bottom">
              聚焦营销体系改革，蓄力高质呈增长
            </div>
          </div>
          <div class="chart13_table_box_option1_right">02-16 上周三</div>
        </div>
        <div class="chart13_table_box_option1">
          <div class="chart13_table_box_option1_left">
            <div class="chart13_table_box_option1_left_top">
              中金公司 <i class="i2">王文丹</i> 张向伟 江澜
            </div>
            <div class="chart13_table_box_option1_left_bottom">
              聚焦营销体系改革，蓄力高质呈增长
            </div>
          </div>
          <div class="chart13_table_box_option1_right">02-16 上周三</div>
        </div>
        <div class="chart13_table_box_option2">
          <div class="chart13_table_box_option1_left">
            <div class="chart13_table_box_option1_left_top">
              中金公司 <i class="i2">王文丹</i> 张向伟 江澜
            </div>
            <div class="chart13_table_box_option1_left_bottom">
              聚焦营销体系改革，蓄力高质呈增长
            </div>
          </div>
          <div class="chart13_table_box_option1_right">02-16 上周三</div>
        </div>
      </div>
      <div style="text-align: right; margin-top: 10px" class="fyq">
        <el-pagination
          background
          layout="pager, next"
          :total="50"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts13() {
      var myChart13 = this.$echarts.init(document.getElementById("Chart13"));
      //配置图表
      var option13 = {
        grid: {
          containLabel: true,
          left: -40,
          right: -10,
          bottom: 0,
          top: 10,
        },
        xAxis: {
          axisTick: {
            show: false,
            lineStyle: {
              width: "122",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ededed",
            },
          },

          data: ["买入", "增持", "中性", "减持", "卖出"],
          axisLabel: {
            formatter: function (value) {
              if (value == "买入") {
                return `{a|${value}}\n{b|1-1.5}`;
              } else if (value == "增持") {
                return `{a|${value}}\n{b|1.5-2.5}`;
              } else if (value == "中性") {
                return `{a|${value}}\n{b|2.5-3.5}`;
              } else if (value == "减持") {
                return `{a|${value}}\n{b|3.5-4.5}`;
              } else if (value == "卖出") {
                return `{a|${value}}\n{b|4.5-5.5}`;
              }
            },
            rich: {
              //富文本样式设置
              a: {
                color: "#666",
              },
              b: {
                color: "#999",
                align: "center",
              },
            },
          },
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "格力电器",
            type: "bar",
            barGap: "100%",
            barWidth: 36,
            label: {
              formatter: "1家",
              show: true,
              position: "top",
            },
            data: [
              {
                value: 26.16,
                itemStyle: {
                  color: "#fd4c4c",
                },
              },
              {
                value: 21.61,
                itemStyle: {
                  color: "#fcad2a",
                },
              },
              {
                value: 9.12,
                itemStyle: {
                  color: "#7a7ef3",
                },
              },
              {
                value: 19.81,
                itemStyle: {
                  color: "#41b357",
                },
              },
              {
                value: 28.96,
                itemStyle: {
                  color: "#fff191",
                },
              },
            ],
            color: "#539cff",
          },
        ],
      };
      myChart13.setOption(option13);
    },
  },
  mounted() {
    this.myEcharts13();
  },
};
</script>

<style scoped>
.chart13 {
  display: flex;
  flex-direction: row;
}
table {
  border-color: #f4f4f4;
  border-collapse: collapse;
}
th,
td {
  width: 110px;
  height: 43px;
  text-align: center;
}
.chart13_table {
  display: flex;
  flex-direction: column;
  /* justify-content: end; */
  margin-left: 100px;
}
th {
  font-size: 16px;
  color: #333333;
  font-weight: 400;
}
.i1 {
  font-style: normal;
  color: #539cff;
}
.i2 {
  font-style: normal;
  color: #fcad2a;
}
.chart13_table_box {
  width: 805px;
  height: 216px;
  border: 1px solid #e9ebf3;
}
.chart13_table_box_option1 {
  padding: 0 25px;
  width: calc(100% - 50px);
  height: 72px;
  border-bottom: 1px solid #e9ebf3;
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.chart13_table_box_option2 {
  padding: 0 25px;
  width: calc(100% - 50px);
  height: 72px;
  /* border-bottom: 1px solid #e9ebf3; */
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.chart13_table_box_option1_left {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.chart13_table_box_option1_right {
  line-height: 72px;
  font-size: 14px;
  color: #666666;
}
.chart13_table_box_option1_left_top {
  font-size: 16px;
  color: #333333;
}
.chart13_table_box_option1_left_bottom {
  font-size: 14px;
  color: #999999;
}
.fyq /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #fcad2a;
  /* color: #fff; */
}
</style>